import { isPersonaEmail, getDisplayEmailFromPersonaEmail } from 'utils/personaEmail'

export const ORG_SHARED_ACCOUNT_PATTERN = /^ou_\d+_\d+_[a-zA-Z0-9]+@/

export const isOrgSharedAccountEmail = (email?: string | null): boolean => {
  if (!email) return false
  const displayEmail = isPersonaEmail(email) ? getDisplayEmailFromPersonaEmail(email) : email
  return ORG_SHARED_ACCOUNT_PATTERN.test(displayEmail)
}

/**
 * org shared 계정 이메일에서 OU 코드를 추출한다.
 * 이메일이 `ou_<숫자>_<숫자>_<코드>@...` 패턴이 아니면 null.
 * 반환값은 소문자로 정규화된다.
 */
export const getOuCodeFromEmail = (email?: string | null): string | null => {
  if (!email) return null
  const displayEmail = isPersonaEmail(email) ? getDisplayEmailFromPersonaEmail(email) : email
  const match = displayEmail.match(/^ou_\d+_\d+_([a-zA-Z0-9]+)@/)
  return match ? match[1].toLowerCase() : null
}
